// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"585":"2a8131658f8615c2","1195":"de7113482b85eed4","2353":"c5fb79aa71ea0dc6","5147":"35dcca891b992ece","7902":"2bd2ab4ea245455d","8214":"1954a3cf15ea2bc5"}[chunkId] + ".js";
};